import { render, staticRenderFns } from "./TheTips.vue?vue&type=template&id=6988f71c&scoped=true&"
import script from "./TheTips.vue?vue&type=script&lang=js&"
export * from "./TheTips.vue?vue&type=script&lang=js&"
import style0 from "./TheTips.vue?vue&type=style&index=0&id=6988f71c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6988f71c",
  null
  
)

export default component.exports